<template>
  <RevIllustration
    :alt="alt || ''"
    :height="size"
    :src="`https://s1.statics.backmarket.com/mobile-plan/${partnerName}/logo.svg`"
    :width="size"
    loading="eager"
  />
</template>

<script setup lang="ts">
import { RevIllustration } from '@ds/components/Illustration'

withDefaults(
  defineProps<{
    partnerName: string
    alt?: string
    size?: number
  }>(),
  {
    size: 24,
  },
)
</script>
